/**
 * The per-field messages the API sends with a rejected save, flattened to one
 * message per field. Shape is zod's `flatten()`, as the staff and meeting
 * routes send it: `{ formErrors, fieldErrors: { key: string[] } }`.
 */
export function fieldErrorsFrom(details: unknown): Record<string, string> {
  const d = details as { fieldErrors?: Record<string, string[]> } | undefined;
  const out: Record<string, string> = {};
  for (const [key, messages] of Object.entries(d?.fieldErrors ?? {})) {
    const first = messages?.[0];
    // zod says "Required"; under a label that reads as a fragment, not a
    // sentence, so it is said the way a person would say it.
    if (first) out[key] = first === 'Required' ? 'This one is needed.' : first;
  }
  return out;
}
